module.exports = __webpack_public_path__ + "img/mozila.b165aa24.gif";